<template>
  <div class="indexcon">
    <Tubiao></Tubiao>
    <div :class="paper.tName ? 'bodytitle' : 'bodytitlenone'"><span>{{ paper.tName }}</span></div>
    <p>{{ paper.tDesc }}</p>
    <!-- <p>选中radioArray：{{form.radioArray}}</p> -->
    <!-- 单选题 -->
    <div class="titxx">{{ paper.tDanx }}</div>
    <div v-for="(item, index) of list2" :key="index" class="ques">
      <!-- <div>
        <h4>{{ index + 1 }}. {{ item.question }}</h4>
      </div> -->
      <div class="questit"><span>{{ index + 1 }}. {{ item.question }}</span></div>
      <el-radio-group v-model="form.radioArray[index]" v-if="item.is_dx == '1'">
        <el-radio v-for="it of item.topicselect" :key="it.id" :label="it.id">
          {{ it.number + ' ' + it.option }}
        </el-radio>
      </el-radio-group>
      <ChangeDate v-if="item.is_dx == '3'" @changeda="changeda"></ChangeDate>
      <div class="text item" v-if="item.is_dx == '4'">
        <el-select v-model="form.radioArray[index]" placeholder="请选择">
          <el-option v-for="it of item.topicselect" :key="it.id" :label="it.option" :value="it.id"></el-option>
        </el-select>
      </div>
    </div>
    <!-- 多选题 -->
    <!-- <p>选中checkedArray：{{form.checkedArray}}</p> -->
    <div class="titxx">{{ paper.tDuox }}</div>
    <div>
      <div v-for="(item3, index3) of list3" :key="index3" class="ques">
        <!-- <div>
          <h4>{{ index3 + 1 }}. {{ item3.question }}</h4>
        </div> -->
        <div class="questit"><span>{{ index3 + 1 }}. {{ item3.question }}</span></div>
        <el-checkbox-group v-model="form.checkedArray">
          <el-checkbox v-for="it3 of item3.topicselect" :key="it3.id" :label="it3.id">
            {{ it3.number + ' ' + it3.option }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!-- 结果：{{reslist}} -->
    <!-- <div class="tjan"><el-button type="text" @click="ontj">提交</el-button></div> -->
    <div class="ticon">
      <div class="tijiaobn">
        <el-button type="text" @click="ontj">提交</el-button>
      </div>
    </div>

    <el-dialog title="结果" :visible.sync="signVisible" :close-on-click-modal="true" :close-on-press-escape="true"
      :width="signDialogWidth" @close="closedia">
      <div>
        <h2>{{ paper.tName }}</h2>
        <p>{{ paper.tDesc }}</p>
        <p>选中radioArray：{{ form.radioArray }}</p>
        <div v-for="(item, index) of list2" :key="index">
          <div>
            <h4>{{ index + 1 }}. {{ item.question }}</h4>
          </div>
          <el-radio-group v-model="form.radioArray[index]">
            <el-radio v-for="it of item.topicselect" :key="it.id" :label="it.id">
              {{ it.number + '. ' + it.option }}
            </el-radio>
          </el-radio-group>
        </div>
        <!-- 结果：{{reslist}} -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Tubiao from "./tubiao.vue";
import ChangeDate from "./changeDate.vue";
export default {
  components: {
    Tubiao,
    ChangeDate
  },
  props: {
    //添加移动端弹框宽度属性，默认为80%
    mobileEndWidth: {
      default: '80%',
      type: String
    },
  },
  data() {
    return {
      // 新增用户设备是移动端的属性
      userAgentMobile: '',
      // 试卷基础信息
      paper: {
        tName: '',
        tDesc: '',
        tDanx: '单选题',
        tDuox: '多选题'
      },
      uid: '',
      yzm: '',
      number: '',
      category_id: '',
      bp_money: '',
      sjh:'',
      form: {
        radioArray: [],
        checkedArray: []
      },
      reslist: [],
      signVisible: false,
      signDialogWidth: '',
      list2: [
        // {
        //   question: '单选题',
        //   topicselect: [
        //     // {id:'', number: '', option: '', pcStatus: null},
        //     // {id:'', number: '', option: '', pcStatus: null},
        //     // {id:'', number: '', option: '', pcStatus: null}
        //   ]
        // }

      ],
      list2_zs: '',
      list3: [
        // {
        //   question: '多选题',
        //   topicselect: [
        //     // {id:'', number: '', option: '', pcStatus: null},
        //     // {id:'', number: '', option: '', pcStatus: null},
        //     // {id:'', number: '', option: '', pcStatus: null}
        //   ]
        // }

      ],
      list3_zs: '',
      nowdate: ""
    };
  },

  computed: {
    style() {
      let style = {};
      if (!this.fullscreen) {
        style.marginTop = this.top;
        if (!this.userAgentMobile) { // pc端时
          if (this.width) { // 传入的width属性有值
            style.width = this.width; // 弹框宽度为width定义的宽度
          }
        } else { // 移动端
          style.width = this.mobileEndWidth // 移动端窗口宽度属性的值
        }
      }
      return style;
    }
  },

  created() {
    this.userAgentMobile = window.innerWidth <= 720 // 检测当前屏幕大小是移动端
    // console.log(this.$route.query.uid);
    // console.log(this.$route.query.tName);
    this.uid = this.$route.query.uid;
    this.paper.tName = this.$route.query.tName;
    this.yzm = this.$route.query.yzm;
    this.number = this.$route.query.number;
    this.category_id = this.$route.query.category_id;
    this.bp_money = this.$route.query.bp_money;
    this.sjh = this.$route.query.sjh;
    //获取题目数据方法
    this.fetchPaper();
    // this.handCheck()
  },
  methods: {
    //axios获取后台api接口
    fetchPaper() {
      let data = this.$qs.stringify({

      });
      // console.log(data)
      this.$axios({
        method: "post",
        url: "/public/index.php/Index/question_phone_collection",
        data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res.data.data.duox_list)
            this.list2 = [];
            let nowdata = res.data.data;
            nowdata.forEach(element => {
              if (element.is_dx == '1' || element.is_dx == '3' || element.is_dx == '4') {
                // 单选
                this.list2.push(element);
              } else if (element.is_dx == '2') {
                //多选题
                this.list3.push(element);
              }
            });

            this.list2_zs = this.list2.length;
            this.list3_zs = this.list3.length;
            //单选题
            // this.list2 = res.data.data.danx_list;
            // this.list2_zs = res.data.data.danx_list.length;
            //多选题
            // this.list3 = res.data.data.duox_list;
            // this.list3_zs = res.data.data.duox_list.length;
          } else {
            // this.$message.error(res.data.message);
            this.$toast(res.data.message, 2000);
          }
        })
        .catch(err => {
          // this.$message.error(err);
          this.$toast(err, 2000);
        });
    },
    // 赋值
    // handCheck(){
    //   const aaa = []
    //   this.list2.forEach((item,index) => {
    //     if(item !== null && item !== undefined){
    //       item.topicselect.forEach(it => {
    //         if(it.pcStatus === 1){
    //           aaa.push(it.id)            
    //          }           
    //       }) 
    //     }      
    //     // if(aaa.length!==index+1){
    //     //   aaa.push(null)
    //     // }
    //   })
    //   this.form.radioArray = aaa
    // },
    // 初始化配置信息
    initSignConfig() {
      this.signDialogWidth = `${document.body.offsetWidth / 2 + 40}px`;
    },
    /**
   * 关闭弹层
   */
    closedia() {
      this.signVisible = false;
      this.form = {
        radioArray: [],
        checkedArray: []
      }

    },
    ontj() {
      // console.log(this.form.radioArray.filter(Boolean).length);
      // console.log(this.list2_zs)
      // console.log(this.form.checkedArray.filter(Boolean).length);
      // console.log(this.list3_zs)
      // console.log(this.nowdate);
      // return 1;

      if (this.form.radioArray.filter(Boolean).length == this.list2_zs -1 && this.form.checkedArray.filter(Boolean).length >= this.list3_zs && this.nowdate !== '') {
        // console.log(this.list2_zs)
        // console.log(this.form.radioArray.filter(Boolean).length);
        this.form.radioArray = this.form.radioArray.filter(item => {
          // 这里检查item是否为“真值”。对于null、undefined、""、NaN、0、false，都会返回false  
          // 注意：空字符串""在这里也被认为是空值，如果你不想剔除它，请修改条件  
          return item != null && item !== "" && !isNaN(item) && item !== false;
        });
        let data = this.$qs.stringify({
          uid: this.uid,
          // question_id: this.form.radioArray.join(','),
          // question_ids: this.form.checkedArray.join(','),
          question_id: this.form.radioArray.join(',') + ',' + this.form.checkedArray.join(','),
          // question_ids: this.form.checkedArray.join(','),
          question_age: this.nowdate,
          yzm: this.yzm,
          category_id: this.category_id,
          bp_money: this.bp_money,
          sjh: this.sjh,
          number: this.number
        });
        // console.log({
        //   uid: this.uid,
        //   // question_id: this.form.radioArray.join(','),
        //   // question_ids: this.form.checkedArray.join(','),
        //   question_id: this.form.radioArray.join(',') + ',' + this.form.checkedArray.join(','),
        //   // question_ids: this.form.checkedArray.join(','),
        //   question_age: this.nowdate,
        //   yzm: this.yzm,
        //   category_id: this.category_id,
        //   bp_money: this.bp_money,
        //   number: this.number
        // });
        // return;
        //显示loading
        this.bus.$emit("loading", true);
        this.$axios({
          method: "post",
          url: "/public/index.php/Index/collection_phone_qustion_tj",
          data: data
        })
          .then(res => {
            if (res.data.code == 200) {
              // console.log(res.data.data)
              // this.signVisible = true;
              //跳转到成功页面
              this.$router.push({
                name: 'Success_tj',
                params: {},
                query: {}
              })
              //关闭loading
              this.bus.$emit("loading", false);
              // this.$message.success(res.data.data);
              // this.$toast(res.data.data,2000);
            } else {
              //关闭loading
              this.bus.$emit("loading", false);
              // this.$message.error(res.data.message);
              this.$toast(res.data.message, 2000);
            }
          })
          .catch(err => {
            // this.$message.error(err);
            this.$toast(err, 2000);
          });

      } else {
        // this.$message.error("请完成测试!");
        this.$toast('请完成测试!', 2000);
        return
      }

    },
    changeda(a) {
      this.nowdate = a;
      // console.log(this.nowdate);
    },


  }
}
</script>

<style scoped lang="scss">
.indexcon {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/img/111.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.bodytitle {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 10%;

  >span {
    font-family: YouSheBiaoTiHei;
    font-size: 5.2vh;

    letter-spacing: 0;
    font-weight: 400;
    // background-image: -webkit-linear-gradient(bottom, #2f92a1, #6bdef0);
    background-image: -webkit-linear-gradient(bottom, #67b5a3, #55c5ad);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: -4px 2px 2px rgba(68, 188, 255, 0.3);
  }
}

.bodytitlenone {
  height: 3%;
}

.titxx {
  font-family: 'PingFang Heavy';
  font-size: 2.8vh;
}

.questit {
  line-height: 3vh;
  font-family: 'PingFang Heavy';
  font-size: 2.5vh;
  margin: 2vh 0 2vh 0;
}

.el-radio,
.el-checkbox {
  margin-bottom: 10px;
  font-size: 2vh;
}

::v-deep .el-radio__label {
  font-size: 2.3vh;
}

::v-deep .el-checkbox__label {
  font-size: 2.3vh;
}

.el-radio-group {
  display: flex;
  flex-direction: column;

  .el-radio {
    line-height: 4vh;


  }

  ::v-deep .el-radio__input {
    line-height: 4.5vh;
  }

}

.el-checkbox-group {
  display: flex;
  flex-direction: column;
}

.el-checkbox-group>>>.el-checkbox__label {
  font-size: 18px;
}

::v-deep .el-checkbox__input {
  line-height: 4.5vh;
}

.ticon {
  width: 100%;
  display: flex;
  justify-content: center;

  .tijiaobn {
    margin: 6vh 0 6vh 0;
    width: 14vh;
    height: 6vh;
    line-height: 6vh;
    background: rgba(36, 151, 254, 1);
    border-radius: 6px;
    color: white;

    .el-button--text {
      color: white;
      font-size: 2.5vh;
    }
  }
}

h4 {
  font-size: 22px;
  padding-bottom: 0px;
  margin-bottom: 15px;
  line-height: 1.5;
}

h2,
p {
  text-align: center;
}

h2 {
  font-size: 28px;
}

p {
  font-size: 20px;
}

.ques {
  width: 83%;
  margin: 0 auto;
  margin-top: 2vh;
  text-align: left;
}

::v-deep .el-radio__label {
  white-space: normal;
  word-break: break-all;
}

.tjan {
  margin-top: 80px;
}

.tjan,
.el-button {
  font-size: 20px;
}
</style>